import React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from '../../../app/AppState';
import { Loading } from '../../../scenes/Loading';

export const PermissionsGate = ({ children }: React.PropsWithChildren<any>) => {
    const isAuthenticated = useSelector((state: AppState) => state.Authentication.get('isAuthenticated'));
    const isLoadingPermissions = useSelector((state: AppState) => !state.Permissions.get('initialized'));

    if (isAuthenticated && isLoadingPermissions) {
        return <Loading />;
    }

    return <React.Fragment>{children}</React.Fragment>;
};
